import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import {  useLocation , useNavigate} from 'react-router-dom';
import { notifySuccess, notifyError } from '../Notification';
import { submitEssayShortResponseForm } from "../api"; // Import the API function
import ThankYouModal from '../layout/ThankyouModal';


const EssayShortResponseForm = () => {
  const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
  const location = useLocation();
    const navigate = useNavigate();
  const child = location.state?.child;
  const [formData, setFormData] = useState({
    qualities: "",
    summerPlans: "",
    personalGrowth: "",
    worldDescription: "",
    ibLearnerProfile: "",
    studentName: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requiredFields = ["qualities", "summerPlans", "personalGrowth", "worldDescription", "ibLearnerProfile", "studentName"];

    for (let field of requiredFields) {
      if (!formData[field]) {
        notifyError("Please complete all required fields.");
        return;
      }
    }

    const formattedData = {
      student_id: child.id,
      ...formData,
    };

    try {
      await submitEssayShortResponseForm(formattedData);
      notifySuccess("Form submitted successfully!");
      setModalVisible(true);
    } catch (error) {
      notifyError("Error submitting form.");
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h4" align="center" gutterBottom>
        ESSAYS AND SHORT RESPONSES
      </Typography>
      <Paper elevation={3}>
        <Box p={2}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">Short Responses</Typography>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Can you name and describe at least four qualities you would like a school to have?"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline
                  rows={6}
                  name="qualities"
                  value={formData.qualities}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Imagine you have this summer to pursue your strongest interest. What would you do? Where and how would you do this?"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline
                  rows={6}
                  name="summerPlans"
                  value={formData.summerPlans}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Describe how some personal experience or individual in the past year or two has influenced your personal growth."
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline
                  rows={6}
                  name="personalGrowth"
                  value={formData.personalGrowth}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Briefly describe the world you live in."
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline
                  rows={6}
                  name="worldDescription"
                  value={formData.worldDescription}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">Essay</Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" paragraph>
                  <strong>IB Learners strive to be:</strong>
                  <br />
                  Inquirers, Knowledgeable, Thinkers, Communicators, Principled,
                  Open-minded, Caring, Risk-takers, Balanced, and Reflective.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Describe your person against one or more of the 10 IB learner's profile."
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline
                  rows={12}
                  name="ibLearnerProfile"
                  value={formData.ibLearnerProfile}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="I certify that the expressed views communicated in the responses and essays are originally my own"
                  variant="outlined"
                  name="studentName"
                  value={formData.studentName}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: "16px" }}
                  type="submit"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>
      <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
    </Box>
  );
};

export default EssayShortResponseForm;
